import React from "react";
import { format } from "date-fns";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "../../TransactionsDataGrid/renderers";

import { GridInvoice } from "../../../types";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const SubmittedDateRenderer = ({ data }: Props) => {
  const firstLine = format(new Date(data.submittedDate), "MMM d, yyyy");
  const secondLine = format(new Date(data.submittedDate), "h:mm a");

  return (
    <TwoLineGridCell firstLineData={firstLine} secondLineData={secondLine} />
  );
};

export default SubmittedDateRenderer;
